import { Platform } from '@angular/cdk/platform';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TrendencySeoService } from '@trendency/utils';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit, AfterViewInit {
  @ViewChild('vid', { static: false }) videoElement: ElementRef<HTMLMediaElement>;

  videoUrl: string = '';
  isLoading = true;
  currentLang: string;

  constructor(
    private readonly seo: TrendencySeoService,
    private readonly router: Router,
    private readonly platform: Platform,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.setMetaData();
    this.currentLang = this.translateService.currentLang;
    if (this.platform.ANDROID || this.platform.IOS) {
      this.videoUrl = `assets/clips/VH-404_mobil/visit_hungary_404_oldal_animacio_${this.currentLang}.mp4`;
    } else {
      this.videoUrl = `assets/clips/VH-404_desktop/visit_hungary_404_oldal_animacio_${this.currentLang}.mp4`;
    }
  }

  ngAfterViewInit(): void {
    const media = this.videoElement.nativeElement;
    media.addEventListener('ended', () => {
      this.returnToHome();
    });

    media.muted = true;
  }

  loaded(): void {
    this.isLoading = false;
  }

  setMetaData(): void {
    const title = this.translateService.instant('404.page-not-found');

    this.seo.setMetaData({
      title: title,
      description: title,
      ogTitle: title,
      ogImage: '',
    });
  }

  returnToHome(): void {
    this.router.navigate(['/', this.currentLang]);
  }
}
